import React from 'react'

import { Title } from '@shared/ui/Typography/Title'
import { Text } from '@shared/ui/Typography/Text'
import Accordion from '@shared/ui/Accordion/Accordion'

import s from './OwnerSubscriptionPage.module.sass'

/**
 * @function FAQ - Вопросы и ответы
 */
const FAQ: React.FC = () => {
  return (
    <div className={s['faq-section']}>
      <Title tag='h3' sizes='h5'>
        Вопросы и ответы
      </Title>

      <div className={s['faq-container']}>
        <Accordion title='Как понять, какой у меня тариф и когда он закончится?' className={s['faq-item']}>
          <Text sizes='M' className={s['faq-answer']}>
            Всю нужную информацию вы найдёте в разделе «Подписка», в блоке «Активная
            подписка»&nbsp;—&nbsp;он&nbsp;расположен в верхней части экрана. Там указано, какой у вас тариф и срок его
            действия
          </Text>
        </Accordion>

        <Accordion title='Чем отличаются тариф «Базовый» и тариф «ПРО»?' className={s['faq-item']}>
          <Text sizes='M' className={s['faq-answer']}>
            «Базовый» тариф дает доступ к работе с отзывами гостей, статистике просмотров страницы и возможности
            публиковать новости в разделе «Спецпредложения». Тариф «ПРО» включает все функции «Базового» и дополняется
            важными преимуществами: сервис бронирования без комиссий, размещение на партнёрских платформах и
            дополнительные упоминания на ресурсах Афиши
          </Text>
        </Accordion>

        <Accordion title='Если я сейчас перейду на тариф «ПРО», потеряю ли базовую подписку?' className={s['faq-item']}>
          <Text sizes='M' className={s['faq-answer']}>
            Мы сохраним неиспользованные дни вашего «Базового» тарифа — они автоматически начнут действовать после
            завершения подписки «ПРО»
          </Text>
        </Accordion>

        <Accordion title='Как оплатить подписку?' className={s['faq-item']}>
          <Text sizes='M' className={s['faq-answer']}>
            Перейдите в раздел «Подписка», выберите удобный для вас срок действия тарифа и оставьте заявку. Мы вышлем
            вам счёт — после его оплаты подписка активируется
          </Text>
        </Accordion>
      </div>
    </div>
  )
}

export default FAQ
